import { SearchResultType } from 'enums'
import { useOrderItemService } from 'services'
import { CatchWeight, OrderItem, OrderItemChange } from 'services/types'
import { SearchResult } from 'types'

type CategorizedOrderItems = {
    notVerifiedItems: OrderItem[]
    shortedItems: OrderItem[]
    changesItems: OrderItem[]
    verifiedItems: OrderItem[]
}

type SearchResults = {
    notVerifiedResults: SearchResult<OrderItem>[]
    shortedResults: SearchResult<OrderItem>[]
    changesResults: SearchResult<OrderItem>[]
    verifiedResults: SearchResult<OrderItem>[]
    allResults: SearchResult<OrderItem>[]
}

export abstract class SearchResultHelper {

    public static categorizeOrderItems = (items: OrderItem[], orderItemsChanges: OrderItemChange[], catchWeights: CatchWeight[]): CategorizedOrderItems => {
        const { isOrderItemComplete } = useOrderItemService()

        return {
            notVerifiedItems: items?.filter(item => !isOrderItemComplete(item)) ?? [],
            shortedItems: items?.filter(item => item.shippedQuantity < item.orderedQuantity) ?? [],
            changesItems: items?.filter(item => (item.shippedQuantity !== item.countedQuantity || (orderItemsChanges.filter(change => change.orderItemId == item.id) && orderItemsChanges.filter(change => change.orderItemId == item.id).length > 0) || (catchWeights.filter(cw => cw.orderItemId == item.id && cw.reconcileReasonId! > 0) && catchWeights.filter(cw => cw.orderItemId == item.id && cw.reconcileReasonId! > 0).length > 0))) ?? [],
            verifiedItems: items?.filter(item => item.verifiedMethod != null) ?? []
        }
    }

    public static convertOrderItemsToSearchResults = (notVerified: OrderItem[], shorted: OrderItem[], changes: OrderItem[], verified: OrderItem[], orderItemsChanges: OrderItemChange[]): SearchResults => {
        const { isOrderItemChangeComplete } = useOrderItemService()
        const notVerifiedResults: SearchResult<OrderItem>[] = notVerified?.map(item => { return { type: SearchResultType.NotVerifiedItem, value: item } }) ?? []
        const shortedResults: SearchResult<OrderItem>[] = (shorted?.map(item => { return { type: SearchResultType.ShortedItem, value: item } }) ?? [])
            .sort((a, b) => a.value.shippedQuantity - b.value.shippedQuantity); //shippedQuantity asc
        const changesResults: SearchResult<OrderItem>[] = (changes?.map(item => { return { type: SearchResultType.ChangedItem, value: item } }) ?? [])
            .sort((a, b) => {
                let aIncompleteChanges: number = orderItemsChanges.filter(changes => changes.orderItemId == a.value.id) ? orderItemsChanges.filter(changes => changes.orderItemId == a.value.id).filter(x => !isOrderItemChangeComplete(x)).length : 0
                let bIncompleteChanges: number = orderItemsChanges.filter(changes => changes.orderItemId == b.value.id) ? orderItemsChanges.filter(changes => changes.orderItemId == b.value.id).filter(x => !isOrderItemChangeComplete(x)).length : 0
                return bIncompleteChanges - aIncompleteChanges
            })
        const verifiedResults: SearchResult<OrderItem>[] = verified?.map(item => { return { type: SearchResultType.VerifiedItem, value: item } }) ?? []
        return {
            notVerifiedResults: notVerifiedResults,
            shortedResults: shortedResults,
            changesResults: changesResults,
            verifiedResults: verifiedResults,
            allResults: [
                ...notVerifiedResults.filter(result =>
                    !changesResults.some(change => result.value.id === change.value.id) &&
                    !shortedResults.some(short => result.value.id === short.value.id)
                ),
                ...shortedResults.filter(result => result.value.verifiedMethod == null),
                ...changesResults,
                ...verifiedResults.filter(result => !changesResults.some(change => result.value.id === change.value.id))
            ]
        }
    }

}